import { useState, useContext, useEffect } from "react";
import "./edit-vendor-info.css";
import { FaTimes } from "react-icons/fa";
import AppContext from "../../../../context/app-context";
import { popup } from "../../../../vanilla-functions/model";

const EditVendorDescription = ({ isOpen, setIsOpen, selectedVendor, fetchVendors }) => {
  const { resolveBackendUrl, setIsLoading, isLoading } = useContext(AppContext);

  const [vendor_description, setVendorDescription ] = useState(selectedVendor?.vendor_description || '');

  const handleChange = (e) => {
    setVendorDescription(e.target.value)
  };

  const url = `${resolveBackendUrl(selectedVendor?.estateID)}/vendor/details/update/${selectedVendor?._id}`;
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "include",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("omstoken"),
        },
        body: JSON.stringify({vendor_description}),
      });

      const returned = await response.json();
      await fetchVendors()
      popup(returned?.status || "Record Updated successfully");
      setIsOpen(false);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      popup("Error communicating with estate server. You can try again later.");
    } finally {
      setIsLoading(false);
    }
  }

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-body">
        <div className="vendor-info-div">
          <div className="vendor-heading-div">
            <div className="vendor-heading">Edit Vendor Description</div>
            <FaTimes onClick={() => setIsOpen(false)} cursor='pointer'/>
          </div>
          <form onSubmit={handleSubmit} className="vendor-info-form">
            <div className="edit-form-input-div">
              <label>Description</label>
              <textarea
                type="text"
                name="vendor_description"
                onChange={handleChange}
                placeholder={selectedVendor?.vendor_description}
              ></textarea>
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditVendorDescription;

